import React, { FC, useState, useMemo, InputHTMLAttributes, ChangeEvent, ChangeEventHandler, useEffect } from 'react'
import cx from 'classnames'
import * as _ from 'lodash'

import SearchInput from '../SearchInput'

type SuggestItem = {
  display: string
  value: any
}

type SelectEventHandler = { bivarianceHack(value: any | null): void }['bivarianceHack']

interface IAutocomplateInput extends InputHTMLAttributes<HTMLInputElement> {
  data?: SuggestItem[]
  onChange?: ChangeEventHandler<HTMLInputElement>
  onSelect?: SelectEventHandler
}

const AutocomplateInput: FC<IAutocomplateInput> = (props: IAutocomplateInput) => {
  const { data, onChange, onSelect, ...rest } = props

  const [value, setValue] = useState<string>('')
  const [isLoading, setLoading] = useState(false)
  const [showSuggestionBox, setSuggestionBox] = useState(false)

  const changeHandler = async (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value)
    setLoading(true)
    setSuggestionBox(false)

    onChange && (await onChange(event))
  }

  useEffect(() => {
    if (value.length === 0) {
      setLoading(false)
      setSuggestionBox(false)
    } else setLoading(true)
  }, [value])

  useMemo(() => {
    if (data && data.length && value.length > 0) {
      setLoading(false)
      setSuggestionBox(true)
    }
  }, [data])

  return (
    <div
      style={{ position: 'relative' }}
      onBlur={() => {
        //if (showSuggestionBox) setSuggestionBox(false)
      }}
    >
      <div className="d-flex align-items-center" style={{ position: 'relative' }}>
        <SearchInput
          {...rest}
          type="text"
          value={value || ''}
          onChange={changeHandler}
          onClick={() => {
            if (value.length > 0 && !showSuggestionBox) setSuggestionBox(true)
          }}
        />
        <div
          className={cx('spinner-border spinner-border-sm text-primary', {
            'd-none': !isLoading,
            'd-block': isLoading,
          })}
          style={{ position: 'absolute', right: 10 }}
        ></div>
      </div>
      <div
        className={cx('card mt-2', {
          'd-none': !showSuggestionBox,
          'd-block': showSuggestionBox,
        })}
        style={{ position: 'absolute', width: '100%', maxHeight: 240, overflowY: 'auto', zIndex: 1 }}
      >
        <ul className="list-group border-0">
          {React.Children.toArray(
            _.map(data, (item) => {
              let str = item.display

              if (value.length > 0) {
                const regex = new RegExp(value, 'gi')
                const founds: any = str.match(regex)

                for (const j in founds) {
                  str = str.replace(founds[j], `<span class="text-warning font-weight-bold">${founds[j]}</span>`)
                }
              }

              return (
                <li
                  className="list-group-item border-0 py-1 my-2 cursor-pointer"
                  onClick={() => {
                    setValue('')
                    onSelect && onSelect(item.value)
                  }}
                >
                  <span dangerouslySetInnerHTML={{ __html: str }} />
                </li>
              )
            })
          )}
        </ul>
      </div>
    </div>
  )
}

export default AutocomplateInput
